import axios from 'axios'

export const syncCatalog = async (data) => {
  const response = await axios.post('/product-catalog/sync', data)
  return response.data.data
}


export const getCatalogConfiguration = async () => {
  const response = await axios.get('/product-catalog/configuration')
  return response.data.data
}

export const updateCatalogConfiguration = async (data) => {
  const response = await axios.put('/product-catalog/configuration', data)
  return response.data.data
}

export const validatePlatformConfiguration = async (platform) => {
  const response = await axios.get(`/product-catalog/validate/${platform}`)
  return response.data.data
}

export const CatalogPlatform = {
  META: 'META',
  GOOGLE: 'GOOGLE',
}

export const CatalogSyncStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  PARTIAL: 'PARTIAL',
}
